import { rupiah, trackClick } from "../../lib/api";

const waNumber = (n) => {
  let d = (n || "").replace(/\D/g, "");
  if (d.startsWith("0")) d = "62" + d.slice(1);
  return d;
};

export const BuyButtons = ({ product, whatsapp = "", size = "sm", prefix = "card" }) => {
  const cls = size === "lg" ? "py-3 text-sm" : "py-2 text-xs";
  const track = (type) => (e) => {
    e.stopPropagation();
    trackClick(product.product_id, type);
  };
  const links = [
    product.shopee_link && { type: "shopee", label: "Shopee", href: product.shopee_link, color: "bg-[#EE4D2D] hover:brightness-110" },
    product.tiktok_link && { type: "tiktok", label: "TikTok", href: product.tiktok_link, color: "bg-slate-900 hover:bg-black" },
  ].filter(Boolean);
  const wa = waNumber(whatsapp);
  if (links.length < 2 && wa) {
    const msg = `Halo, saya mau beli ${product.name} (${rupiah(product.price)}).\n${window.location.origin}${window.location.pathname}?p=${product.product_id}`;
    links.push({ type: "whatsapp", label: links.length ? "WA" : "Beli via WhatsApp", href: `https://wa.me/${wa}?text=${encodeURIComponent(msg)}`, color: "bg-[#25D366] hover:brightness-105" });
  }
  if (!links.length) return null;
  return (
    <div className={`grid gap-2 ${links.length > 1 ? "grid-cols-2" : "grid-cols-1"}`}>
      {links.map((l) => (
        <a key={l.type} href={l.href} target="_blank" rel="noopener noreferrer" onClick={track(l.type)} data-testid={`${prefix}-${l.type}-btn-${product.product_id}`}
          className={`${cls} ${l.color} rounded-xl text-center font-semibold text-white active:scale-[0.98] transition truncate px-2`}>
          {l.label}
        </a>
      ))}
    </div>
  );
};
